import { useState } from "react";
import {
  Box,
  Button,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { addOutlet } from "../../app/services/OutletService";
import {
  fetchOrganisation,
  Organisation,
} from "../../app/services/OrganisationService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { fetchStates, States } from "../../app/services/StatesService";
import { handleInputChange } from "../../app/helpers/validations";
import FormPageWrapper from "../../app/shared/common/form/FormPageWrapper";
const AddOutlet = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [secmobile, setSecMobile] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [shopLicense, setShopLicense] = useState("");
  const [fssaiNumber, setFssaiNumber] = useState("");
  const [licenseRegistrationNumber, setLicenseRegistrationNumber] =
    useState("");
  const [shippingAddressline1, setShippingAddressline1] = useState("");
  const [shippingAddressline2, setShippingAddressline2] = useState("");
  const [shippingPincode, setShippingPincode] = useState("");
  const [billingAddressline1, setBillingAddressline1] = useState("");
  const [billingAddressline2, setBillingAddressline2] = useState("");
  const [billingPincode, setBillingPincode] = useState("");
  const navigate = useNavigate();

  const [organisationList, setOrganisationList] = useState<Organisation[]>([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState("");

  const [stateList, setStateList] = useState<States[]>([]);
  const [selectedState, setSelectedState] = useState("");

  const [selectedCity, setSelectedCity] = useState("");
  const [selectedBillingState, setSelectedBillingState] = useState("");
  const [selectedBillingCity, setSelectedBillingCity] = useState("");
  const [landMark, setLandMark] = useState("");

  const handleReset = () => {
    setName("");
    setEmail("");
    setMobile("");
    setSecMobile("");
    setPanNumber("");
    setGstNumber("");
    setShippingAddressline1("");
    setShippingPincode("");
    setBillingAddressline1("");
    setBillingPincode("");
    setShopLicense("");
    setFssaiNumber("");
    setLicenseRegistrationNumber("");
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      toast.error("Name is required");
      return;
    }

    if (!email.trim()) {
      toast.error("Email is required");
      return;
    }

    if (mobile.trim().length != 10) {
      toast.error("Enter valid mobile number");
      return;
    }
    if (!panNumber.trim()) {
      toast.error("Pan number is required");
      return;
    }
    if (!gstNumber.trim()) {
      toast.error("Gst number is required");
      return;
    }

    if (!shippingAddressline1.trim()) {
      toast.error("Address is required");
      return;
    }
    if (!shippingPincode.trim()) {
      toast.error("Pincode is required");
      return;
    }

    const payload = {
      name,
      org_id: selectedOrganisation,
      email,
      mobile,
      secondary_mobile: secmobile,
      pan_number: panNumber,
      gst_number: gstNumber,
      fssai_number: fssaiNumber,
      license_registration_number: licenseRegistrationNumber,
      shop_license: shopLicense,
      shipping_addressline1: shippingAddressline1,
      shipping_addressline2: shippingAddressline2,
      shippingpincode: shippingPincode,
      shippingstateid: selectedState || Number(selectedState),
      shippingcity: selectedCity,
      land_mark: landMark,
      billing_addressline1: billingAddressline1,
      billing_addressline2: billingAddressline2,
      billingpincode: billingPincode,
      billingstateid: selectedBillingState || Number(selectedBillingState),
      billingcity: selectedBillingCity,
      lat: "21.0760",
      long: "52.8777",
    };

    try {
      const response = await addOutlet(payload);
      if (response.data.status === "success") {
        toast.success("Outlet saved successfully!");
        handleReset();
        navigate("/organisation/outlet");
      } else {
        toast.error(response.data.message);
      }
    } catch (error: any) {
      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to save outlet.";
      toast.error(errMsg);
    }
  };

  useEffect(() => {
    const loadOrganisation = async () => {
      try {
        const res = await fetchOrganisation();
        if (res.status === "success") {
          setOrganisationList(res.data); // Adjust if your API structure is different
        }
      } catch (err) {
        toast("Failed to load organisation");
      }
    };

    loadOrganisation();
  }, []);

  useEffect(() => {
    const loadStates = async () => {
      try {
        const res = await fetchStates();
        if (res.status === "success") {
          setStateList(res.data); // Adjust if your API structure is different
        }
      } catch (err) {
        toast("Failed to load states");
      }
    };

    loadStates();
  }, []);

  return (
    <FormPageWrapper title="Add New Outlet">
      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Organisation <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <Select
          fullWidth
          displayEmpty
          value={selectedOrganisation}
          onChange={(e) => setSelectedOrganisation(e.target.value)}
        >
          <MenuItem value="" disabled>
            Select a organisation
          </MenuItem>
          {organisationList.map((org) => (
            <MenuItem key={org.id} value={org.id}>
              {org.name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Name <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter name"
          value={name}
          onChange={(e) => handleInputChange(e, "name", setName)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Email <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => handleInputChange(e, "email", setEmail)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Mobile <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Mobile"
          value={mobile}
          onChange={(e) => handleInputChange(e, "mobile", setMobile)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Secondary Mobile
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Secondary Mobile"
          value={secmobile}
          onChange={(e) => handleInputChange(e, "mobile", setSecMobile)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Pan Number <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Pan Number"
          value={panNumber}
          onChange={(e) => handleInputChange(e, "pan", setPanNumber)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Gst Number <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Gst Number"
          value={gstNumber}
          onChange={(e) => handleInputChange(e, "gst", setGstNumber)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Shop License 
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Shop License"
          value={shopLicense}
          onChange={(e) => handleInputChange(e, "license", setShopLicense)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          FSSAI Number 
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter FSSAI Number"
          value={fssaiNumber}
          onChange={(e) => handleInputChange(e, "fssai", setFssaiNumber)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          License Registration Number 
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter License Registration Number"
          value={licenseRegistrationNumber}
          onChange={(e) =>
            handleInputChange(e, "registration", setLicenseRegistrationNumber)
          }
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Shipping Address Line1 <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Address"
          value={shippingAddressline1}
          onChange={(e) =>
            handleInputChange(e, "address", setShippingAddressline1)
          }
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Shipping Address Line2 
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Address"
          value={shippingAddressline2}
          onChange={(e) =>
            handleInputChange(e, "address", setShippingAddressline2)
          }
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Shipping State <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <Select
          fullWidth
          displayEmpty
          value={selectedState}
          onChange={(e) => setSelectedState(e.target.value)}
        >
          <MenuItem value="" disabled>
            Select a state
          </MenuItem>
          {stateList.map((state) => (
            <MenuItem key={state.id} value={state.id}>
              {state.name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Shipping City <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter City"
          value={selectedCity}
          onChange={(e) => handleInputChange(e, "name", setSelectedCity)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Shipping Pincode <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Pincode"
          value={shippingPincode}
          onChange={(e) => handleInputChange(e, "pincode", setShippingPincode)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Landmark
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Land Mark"
          value={landMark}
          onChange={(e) => handleInputChange(e, "address", setLandMark)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Billing Address Line1
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Billing Address"
          value={billingAddressline1}
          onChange={(e) =>
            handleInputChange(e, "address", setBillingAddressline1)
          }
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Billing Address Line2
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Billing Address"
          value={billingAddressline2}
          onChange={(e) =>
            handleInputChange(e, "address", setBillingAddressline2)
          }
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Billing State
        </InputLabel>
        <Select
          fullWidth
          displayEmpty
          value={selectedBillingState}
          onChange={(e) => setSelectedBillingState(e.target.value)}
        >
          <MenuItem value="" disabled>
            Select a state
          </MenuItem>
          {stateList.map((state) => (
            <MenuItem key={state.id} value={state.id}>
              {state.name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Billing City
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Billing City"
          value={selectedBillingCity}
          onChange={(e) => handleInputChange(e, "name", setSelectedBillingCity)}
        />
      </Box>

      <Box mb={3}>
        <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
          Billing Pincode
        </InputLabel>
        <TextField
          fullWidth
          size="medium"
          placeholder="Enter Billing Pincode"
          value={billingPincode}
          onChange={(e) => handleInputChange(e, "pincode", setBillingPincode)}
        />
      </Box>

  
      <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
        <Button
          variant="outlined"
          onClick={handleReset}
          sx={{
            px: 4,
            py: 1.2,
            fontWeight: 600,
            borderColor: "#fcb500",
            color: "#fcb500",
            "&:hover": {
              backgroundColor: "#fff8e1",
              borderColor: "#fcb500",
            },
          }}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            px: 4,
            py: 1.2,
            backgroundColor: "#fcb500",
            color: "#000",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "#fbc02d",
            },
          }}
        >
          Save
        </Button>
      </Box>
    </FormPageWrapper>
  );
};

export default AddOutlet;
